import { render, staticRenderFns } from "./AnswerStar.vue?vue&type=template&id=8f133a0e&"
import script from "./AnswerStar.vue?vue&type=script&lang=js&"
export * from "./AnswerStar.vue?vue&type=script&lang=js&"
import style0 from "./AnswerStar.vue?vue&type=style&index=0&id=8f133a0e&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports